<div fxLayout="row column" fxFlex="100" fxLayoutAlign="center center">
  <!-- *appCanAccess="'indesign.industrialBearingConfigurator'"> -->
  <button type="submit" fxFlex="80" mat-raised-button class="chronos-cockpit">
    <a [href]="url" target="_blank" class="btn-block btn-lg width-90-pc" type="submit">{{ linkText }}</a>
  </button>
</div>
